import { render, staticRenderFns } from "./ParticipantVcEditor.vue?vue&type=template&id=fb99df5c&scoped=true&"
import script from "./ParticipantVcEditor.vue?vue&type=script&lang=ts&"
export * from "./ParticipantVcEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantVcEditor.vue?vue&type=style&index=0&id=fb99df5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb99df5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
